"use client";

import { JobFunction, JobFunctionCard } from "@entities/job-function";
import { ButtonLink, TPopularJobFunctionSection } from "@shared/cms";

export function PopularJobFunctionSectionContent({ data, meta }: { data: JobFunction[]; meta: TPopularJobFunctionSection }) {
  if (!data || (data && data.length <= 0)) {
    return <></>;
  }

  return (
    <section className="pb-14 pt-10 sm:pb-10">
      <div className="container">
        <div className="text-2xl sm:text-4xl font-bold mb-8 sm:mb-[60px] text-center">{meta.title}</div>
        <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-4 sm:gap-6">
          {data.map((it, index) => {
            return <JobFunctionCard key={it.id} data={it} index={index} />;
          })}
        </div>
        <div className="mt-8 sm:mt-20">
          <div className="flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-6 justify-center">
            <div className="text-sm sm:text-base text-gray-700 font-medium">{meta.footnote}</div>
            <div>
              <ButtonLink {...meta.button} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
